import _ from 'lodash'

import Toast from '@stackhouse/dashboard-components/Toast'
import Alert from '@stackhouse/dashboard-components/Alert'

let startTime = +new Date()
const authThreshold = 5000

const getError = async data => {

    if (data) {
        if (data instanceof Blob) {
            if (data.type && data.type.includes('json')) {
                return JSON.parse(await (data.text()))
            }
            return await (data.text())
        }

        return data
    }

    return null
}

const getGenericError = status => {

    if (status == 404) {
        return 'Not found.'
    }
    else if (status >= 500) {
        return 'Server error.'
    }
    else {
        return 'Generic error.'
    }
}

export const getErrorMessage = async (error) => {
    const errorData = await getError(error.response.data)
    return typeof errorData == 'string'
        ? (errorData || getGenericError(error.response.status))
        : (errorData)
            ? errorData.errorDetail
                ? errorData.errorDetail.invalidFields
                    ? Object.values(errorData.errorDetail.invalidFields).join('\n')
                    : ''
                : errorData.errorMessage
            : 'Generic error'
}

const showWarnings = async (warnings) => {

    const results = []

    try {
        for (let warning of warnings) {
            await new Promise((resolve, reject) => Alert.alert({
                type: 'warning',
                closeOnClick: false,
                text: warning.warningMessage,
                textProps: {
                    display: 'block',
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left',
                },
                buttons: warning.answers.map(answer => {
                    return {
                        title: answer.label,
                        outline: !answer.sendResponseBack,
                        onClick: (button, index, requestClose) => {
                            if (answer.sendResponseBack) {
                                results.push({ ...warning, selectedAnswer: answer.index })
                                requestClose()
                                resolve()
                            }
                            else {
                                requestClose()
                                reject()
                            }
                        }
                    }
                })
            }, { target: 'root', closeOnClick: false }))
        }
    }
    catch (error) {
        return null
    }

    return results
}

const handleAPIError = async (getDashboard, error) => {

    console.log(error)
    console.log(error.response)

    if (_.get(error, 'response.config.ignoreError')) {
        return Promise.reject(error)
    }
    else if (!error || !error.response || error.response.status == 0) {
        Toast.toast({ type: 'error', text: 'Network error.', fixed: false }, { overlay: true })
        return Promise.reject(error)
    }
    else if (error.response.status == 401) {
        if ((+new Date() - startTime) > authThreshold) {
            Toast.toast({ type: 'error', text: 'Invalid or expired login.', fixed: false }, { overlay: true })
        }

        const dashboard = getDashboard()

        if (dashboard && dashboard.setUser) {
            dashboard.setUser(null, null)
        }
        return Promise.reject(error)
    }
    else if (error.response.status >= 400) {
        const errorData = await getError(error.response.data)
        if (_.has(errorData, 'errorDetail.warningInfo')) {

            const dashboard = getDashboard()
            const { warningList } = errorData.errorDetail.warningInfo
            const sortedWarningList = warningList.sort((a, b) => a.order - b.order)

            const warningResponse = await showWarnings(sortedWarningList)

            if (warningResponse && dashboard && dashboard.client) {
                return dashboard.client({
                    ...error.config,
                    data: JSON.stringify({
                        ...JSON.parse(error.config.data),
                        warningInfo: {
                            warningList: warningResponse
                        }
                    })
                })
            }

        }
        else {
            const errorMessage = await getErrorMessage(error)

            if (errorMessage) {
                Toast.toast({ type: 'error', text: errorMessage, fixed: false }, { overlay: true })
            }
        }
        return Promise.reject(error)
    }

    return Promise.reject(error)
}


export default handleAPIError